/**
 * DiscardChangesDialog component for RMC Order Edit
 */

import React from 'react'
import {useTranslation} from 'react-i18next'
import {Dialog, DialogTitle, DialogContent, DialogActions, Button} from '@mui/material'

interface DiscardChangesDialogProps {
  open: boolean
  onCancel: () => void
  onDiscard: () => void
}

export const DiscardChangesDialog: React.FC<DiscardChangesDialogProps> = ({
  open,
  onCancel,
  onDiscard
}) => {
  const {t} = useTranslation()

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t('orderIntake.rmc.orderManagement.discardChangesTitle', 'Discard changes?')}
      </DialogTitle>
      <DialogContent>
        {t(
          'orderIntake.rmc.orderManagement.discardChangesMessage',
          'You have unsaved changes. Are you sure you want to discard them?'
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onCancel}
          color="primary"
          variant="text"
          data-test-id="discard-changes-cancel-button"
        >
          {t('orderIntake.rmc.orderManagement.continueEditing', 'Continue editing')}
        </Button>
        <Button
          onClick={onDiscard}
          color="primary"
          variant="contained"
          data-test-id="discard-changes-confirm-button"
        >
          {t('orderIntake.rmc.orderManagement.discardChanges', 'Discard changes')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
